import ProfileHeroEdit from './ProfileHeroEditControls';
import ProfileHeroEditContainer from './ProfileHeroEditControls.container';

export default ProfileHeroEditContainer(ProfileHeroEdit);
